import {API_HOST, AXIOS_INSTANCE} from './api'
import axios from 'axios'

const CUSTOMER_ENDPOINT = "customer";
const HEALTHID_DIGITAL_ENDPOINT = "healthid-digital";
const CUSTOMER_RISKS = "customer/metrics/updated";
const CUSTOMER_ANSWERS = "customer/answers";

export async function GET_CUSTOMER() {
	const response = await AXIOS_INSTANCE.get(`${API_HOST}/${CUSTOMER_ENDPOINT}/user`, {
		headers: {
		'Authorization': 'Bearer ' + window.localStorage.getItem('token')
		}
	});
	return response.data;
}

export function POST_CUSTOMER(form) {
	return AXIOS_INSTANCE.post(`${API_HOST}/${CUSTOMER_ENDPOINT}`, form,
		{
		headers: {
			'Authorization': 'Bearer ' + window.localStorage.getItem('token')
		}
		});
}

export async function PUT_CUSTOMER(form) {
	const response = await AXIOS_INSTANCE.post(`${API_HOST}/${CUSTOMER_ENDPOINT}`, form, {
		headers: {
		'Authorization': 'Bearer ' + window.localStorage.getItem('token')
		}
	});
	return response.data;
}

export async function GET_HEALTHID_DIGITAL() {
	const response = await AXIOS_INSTANCE.get(`${API_HOST}/${HEALTHID_DIGITAL_ENDPOINT}`, {
		headers: {
		'Authorization': 'Bearer ' + window.localStorage.getItem('token')
		}
	});
	return response.data;
}

export async function GET_CUSTOMER_ANSWERS() {
	const response = await AXIOS_INSTANCE.get(`${API_HOST}/${CUSTOMER_ANSWERS}`, {
		headers: {
			'Authorization': 'Bearer ' + window.localStorage.getItem('token')
		}
	});
	return response.data;
}

export async function GET_CUSTOMER_RISKS() {
  const response = await AXIOS_INSTANCE.get(`${API_HOST}/${CUSTOMER_RISKS}`, {
    headers: {
      'Authorization': 'Bearer ' + window.localStorage.getItem('token')
    }
  });
  return response.data;
}

export async function GET_PROFILE_PICTURE() {
  const response = await AXIOS_INSTANCE.get(`${API_HOST}/${CUSTOMER_ENDPOINT}/picture`, {
    headers: {
      'Authorization': 'Bearer ' + window.localStorage.getItem('token')
    }
  });
  return response.data;
}


// WEBPACK FOOTER //
// ./src/services/customer.js